<template>
  <v-container
    class="publish-view"
    align-center
    justify-center
  >
    <page-title title="Publish"></page-title>
    <Tabs :settings="tabSettings"></Tabs>
    <v-layout v-if="loading" column fill-height align-center justify-center>
      <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <v-layout v-if="!loading" column align-center justify-center fill-height>
      <div class="header">Well done! Show proof cards on the pages you prefer</div>
      <div class="preview-link-box">
        Check the proof widget
        <a
          target="_blank"
          :href="
            '/preview-manager/proog/' +
              $store.getters['user/currentCampaign'].id
          "
          >preview here</a
        >
      </div>

      <v-layout  class="publish-path-select " align-center justify-center>
        <span class="publish-path-select-label">
          Publish proof cards 
        </span>
        <!-- <v-radio-group v-model="driverQuestion.enabled" :mandatory="false" row>
          <v-radio label="All" value="ALL"></v-radio>
          <v-radio label="None" value="NONE"></v-radio>
          <v-radio label="Unhappy Customers" value="UNHAPPY"></v-radio>
        </v-radio-group> -->
        <v-select
            class="lg-select"
            :items="publishOptions"
            item-text="label"
            item-value="id"
            solo
            style="height: 40px; width: 250px;"
            v-model="options.publish_settings.selection"
            @change='save'
          ></v-select>
      </v-layout>

      <textarea ref="textarea" 
        v-model="paths"
        class="path-textarea" 
        :disabled="publishOption=='NOWHERE'" >
      </textarea>
      <!--<script>-->
      <!--var loyagram = new LoyagramWidget('{{ campaignSettings.id }}')-->
      <!--loyagram.setUserId('test@domain.com')-->
      <!--loyagram.setAttributes({planId: 1, product: test})-->
      <!--</script>-->
      <div class="actions">
        <router-link
          :to="{
            name: routeNames.SCRIPT_COPY,
            params: {
              projectId: $store.getters['user/currentCampaign'].project_id,
              campaignId: $store.getters['user/currentCampaign'].id
            }
          }"
          ><v-btn color="primaryLight1 pa-3" dark depressed large>
          <img
            class="v-icon v-icon--left"
            :src="require('@/assets/script.svg')"
          />  View Code Snippet
          </v-btn></router-link
        >
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import debounce from 'lodash/debounce'
import proofApi from '@/api/proof'
import CopyCode from '@/components/survey/CopyCode'
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'ProofPublishView',
  components: {
    CopyCode,
    Tabs
  },
  data(){
    return {
      routeNames: routes,
      loading: true,
      publishOption: 'ALL_PAGES_EXCEPT',
      publishOptions: [
        {
          id: 'ALL_PAGES_EXCEPT',
          label: 'All pages except'
        },
        {
          id: 'SPECIFIC_PAGES',
          label: 'On these specific pages'
        },
        {
          id: 'NOWHERE',
          label: 'Nowhere'
        }
      ],
      options: {"close_delay":1,"msg_delay":1,"publish_settings":{"selection":"ALL_PAGES_EXCEPT","urls":[]}},
      initComplete: false
    }
  },
  computed: {
    tabSettings: function() {
      return {
        preselected: null,
        tabs: [
          {
            id: routes.PROOF_SETTINGS,
            label: 'Settings'
          },
          {
            id: routes.PROOF_INTEGRATIONS,
            label: 'Integrations'
          },
          {
            id: routes.PROOF_PUBLISH,
            label: 'Publish'
          }
        ]
      }
    },
    paths: {
      get() {
        if(this.options)
          return this.options.publish_settings.urls.join('\n')
        else return ''
      },
      set(val){
        this.options.publish_settings.urls = val.split('\n')
        if(!this.initComplete){
          this.initComplete = true
          return
        }
        this.save()
      }
    }
  },
  mounted() {
    const vm = this
    proofApi
      .getSettings(this.$router.currentRoute.params.campaignId)
      .then(function(res) {
        console.log(res)
        vm.options = res.data.results.options
        vm.loading = false
      })
      .catch(function(res) {
        vm.loading = false
      })
  },
  methods: {
    save: debounce(function() {
      this.options.campaignId = this.$store.getters['user/currentCampaign'].id
      proofApi
        .saveSettings(this.$router.currentRoute.params.campaignId, {
          options: this.options
        })
        .then(function(campaign) {
          console.log(campaign)
        })
    }, 500),
  }
}
</script>

<style lang="stylus">
  .publish-view {
    text-align: center
    .header {
        font-size: 18px
        color: $color-primary-light-5
    }
    .preview-link-box {
        margin-top 25px
        margin-bottom 50px
        font-size 16px
        a {
          font-weight  bold
          text-underline none
          text-decoration none
          padding-bottom 3px
          border-bottom 3px solid $color-accent
        }
    }

    .copy-header {
      margin-top 75px
      font-size 16px
      font-weight 500
      margin-bottom  18px
    }

    .publish-path-select {
      flex 0
      margin-bottom 50px
      .publish-path-select-label {
        margin-right 20px  
      }
      .lg-select .v-input__slot {
        border: 1px solid $color-primary-light-5 !important
      }
    }

    .path-textarea {
        background: $color-primary-light-7;
        border: 1px solid $color-primary-light-8;
        box-sizing: border-box;
        border-radius: 5px;
        width 500px
        height: 135px;
        padding: 25px;
        overflow-y: hidden;
        outline none
        &:focus{
          border: 1px solid $color-primary-light-8 !important
        }
    }

    .copy-code-button {
        background-color $color-primary-light-1
    }

    .actions {
        margin-top 50px
        .or {
            margin 30px 0
        }
        a {
            text-decoration none
            text-underline none
        }
    }
}
</style>
